<template>
  <div>
    <div class="common-header">
      <div class="common-header-right">
        <div class="common-header-block">
          <el-select v-model="condition.matchStatus" placeholder="请选择">
            <el-option
              v-for="item in gameTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="common-header-block">
          <el-select v-model="condition.gameType" placeholder="请选择">
            <el-option
              v-for="item in gameStates"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="common-header-block">
          <el-input
            class="common-el-input"
            placeholder="输入赛事名称查询"
            v-model="condition.matchName"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
          <el-button type="primary" @click="searchGame()">搜索</el-button>
        </div>
      </div>
    </div>
    <div class="common-table">
      <el-table
        v-loading="loading"
        :data="sng.sngList"
        row-key="id"
        height="100%"
      >
        <el-table-column
          label="赛事ID"
          align="center"
          prop="matchId"
          width="150"
        />
        <el-table-column
          label="标题"
          width="150"
          align="center"
          prop="matchName"
        />
        <el-table-column label="类别" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.gameType == 1">积分赛</span>
            <span v-else>实物赛</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            <el-tag
              :type="
                scope.row.matchStatus == 0 || scope.row.matchStatus == 1
                  ? 'info'
                  : scope.row.matchStatus == 2
                  ? 'success'
                  : scope.row.matchStatus == 3 || scope.row.matchStatus == 4
                  ? 'warn'
                  : 'danger'
              "
              effect="dark"
            >
              {{
                scope.row.matchStatus == 0
                  ? "已创建"
                  : scope.row.matchStatus == 1
                  ? "未开赛"
                  : scope.row.matchStatus == 2
                  ? "比赛中"
                  : scope.row.matchStatus == 3
                  ? "已结束"
                  : scope.row.matchStatus == 4
                  ? "已解散"
                  : "异常"
              }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          min-width="150"
          align="center"
          prop="createTime"
        />
        <el-table-column label="创建者" align="center" prop="creatorName" />
        <el-table-column
          label="开始日期"
          min-width="150"
          align="center"
          prop="startTime"
        >
        </el-table-column>
        <el-table-column label="操作" align="center" width="100">
          <template slot-scope="scope">
            <el-button
              @click="checkGame(scope.row.matchId)"
              v-if="scope.row.matchStatus == 3"
              type="success"
              >查看</el-button
            >
            <el-button
              @click="dismissGame(scope.row.matchId)"
              v-if="
                scope.row.matchStatus == 0 ||
                  scope.row.matchStatus == 1 ||
                  scope.row.matchStatus == 2
              "
              type="danger"
              >解散</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination
      class="common-el-pagination"
      layout="prev,pager,next,jumper"
      background
      :page-size="20"
      :pager-count="5"
      :total="sng.sngListTotal"
      :current-page="currentPage"
      @current-change="searchGame({ page: $event })"
    />
    <el-dialog
      title="游戏详情"
      :visible.sync="centerDialogVisible"
      width="80%"
      center
    >
      <div class="dialog-content">
        <div class="content-body">
          <div class="integral">
            <div class="content-condition">
              <div clsss="condition-item">
                赛事名称
                <el-input
                  v-model="sngDetail.matchName"
                  placeholder="请输入少于30个字符"
                ></el-input>
              </div>
              <div clsss="condition-item">
                <div>开赛时间</div>
                <el-date-picker
                  v-model="sngDetail.startTime"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间"
                >
                </el-date-picker>
                <div class="icon-question">?</div>
              </div>
              <div clsss="condition-item">
                盲注表类型
                <el-radio-group v-model="sngDetail.blindTypeLabel">
                  <el-radio-button label="快速盲注"></el-radio-button>
                  <el-radio-button label="普通盲注"></el-radio-button>
                </el-radio-group>
              </div>
            </div>
            <div class="content-main">
              <el-card class="box-card">
                <div class="block">
                  基础设置
                </div>
                <div class="block">
                  <el-card class="box-card">
                    <div>报名费：{{ sngDetail.registationFee }}</div>
                    <el-slider
                      v-model="sngDetail.registationFee"
                      show-input
                    ></el-slider>
                  </el-card>
                  <el-card class="box-card">
                    <div>升盲时间：{{ sngDetail.updateBlindTime }}</div>
                    <el-slider
                      v-model="sngDetail.updateBlindTime"
                      show-input
                    ></el-slider>
                  </el-card>
                  <el-card class="box-card">
                    <div>起始记分牌：{{ sngDetail.initialScore }}</div>
                    <el-slider
                      v-model="sngDetail.initialScore"
                      show-input
                    ></el-slider>
                  </el-card>
                  <el-card class="box-card">
                    <div>参赛人数上限：{{ sngDetail.upperLimitPlayers }}</div>
                    <el-slider
                      v-model="sngDetail.upperLimitPlayers"
                      show-input
                    ></el-slider>
                  </el-card>
                  <el-card class="box-card">
                    <div>参赛人数下限：{{ sngDetail.lowerLimitPlayers }}</div>
                    <el-slider
                      v-model="sngDetail.lowerLimitPlayers"
                      show-input
                    ></el-slider>
                  </el-card>
                  <!-- <el-card class="box-card">
                                        <div>
                                        <span>盲注表倍数：{{}}倍盲注表</span>
                                        <span style="color:blue;float:right;">查看盲注表</span>
                                        </div>
                                    <el-slider v-model="form." show-input></el-slider>
                                    </el-card> -->
                </div>
              </el-card>
              <el-card class="box-card">
                <div class="block">
                  <div>高级设置</div>
                  <el-switch
                    v-model="advancedSetting"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                  >
                  </el-switch>
                </div>
                <div class="block">
                  <el-card class="box-card">
                    <div>重构次数：{{ sngDetail.allowRebuyTimes }}</div>
                    <el-slider
                      v-model="sngDetail.allowRebuyTimes"
                      show-input
                    ></el-slider>
                  </el-card>
                  <el-card class="box-card">
                    <div>
                      延迟报名盲注级别：{{ sngDetail.allowDelayMaxBlindLevel }}
                    </div>
                    <el-slider
                      v-model="sngDetail.allowDelayMaxBlindLevel"
                      show-input
                    ></el-slider>
                  </el-card>
                  <el-card class="box-card">
                    <div>
                      截止重购盲注级别：{{ sngDetail.allowRebuyMaxBlindLevel }}
                    </div>
                    <el-slider
                      v-model="sngDetail.allowRebuyMaxBlindLevel"
                      show-input
                    ></el-slider>
                  </el-card>
                  <el-card class="box-card">
                    <div>
                      <div>设置配置</div>
                      <el-checkbox-group v-model="sngDetail.control">
                        <el-checkbox label="GPS限制"></el-checkbox>
                        <el-checkbox label="IP控制"></el-checkbox>
                      </el-checkbox-group>
                    </div>
                    <div>
                      <div>猎人赛</div>
                      <el-switch
                        v-model="sngDetail.isHuntsmanMatch"
                        active-text="开"
                        inactive-text=""
                      >
                      </el-switch>
                    </div>
                    <div>
                      <div>赏金比例</div>
                      <el-input
                        placeholder="请输入比例"
                        v-model="sngDetail.huntsmanBonusPercent"
                      >
                        <template slot="append"
                          >%</template
                        >
                      </el-input>
                    </div>
                  </el-card>
                </div>
              </el-card>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="centerDialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import utils from "../../../utils/util";
export default {
  // components: {
  //   compClubConfig
  // },
  data() {
    return {
      loading: false,
      centerDialogVisible: false,
      advancedSetting: false,
      date: null,
      searchVal: "",
      configInfo: {},
      currentPage: 1,
      condition: {
        gameType: "0", //状态
        matchStatus: "-1", //类型
        matchName: "",
        size: 20,
      },
      gameTypes: [
        {
          label: "全部状态",
          value: "-1",
        },
        {
          label: " 已创建",
          value: "0",
        },
        {
          label: "未开赛",
          value: "1",
        },
        {
          label: "进行中",
          value: "2",
        },
        {
          label: "已结束",
          value: "3",
        },
        {
          label: "已解散",
          value: "4",
        },
        {
          label: "异常终止",
          value: "5",
        },
      ],
      gameStates: [
        {
          label: "全部条件",
          value: "0",
        },
        {
          label: "积分赛",
          value: "1",
        },
        {
          label: "实物赛",
          value: "2",
        },
      ],
    };
  },
  computed: {
    ...mapState("sng", ["sng", "sngDetail"]),
    userType() {
      return localStorage.getItem("authTypeCode");
    },
  },
  created() {
    this.searchGame({ page: 1 });
    if (this.sngDetail.blindType == 1) {
      this.sngDetail.blindTypeLabel = "快速盲注";
    } else {
      this.sngDetail.blindTypeLabel = "普通盲注";
    }
    this.sngDetail.startTime == "0" || !this.sngDetail.startTime
      ? "-"
      : utils.getUTime(this.sngDetail.startTime);
  },
  methods: {
    ...mapActions("sng", ["sngDetailApi", "disSngApi", "sngListApi"]),
    // 俱乐部列表
    searchGame(obj = {}) {
      this.loading = true;
      let params = this.condition;
      var self = this;
      params.userId = localStorage.userId;
      Object.assign(params, obj);
      this.currentPage = params.page;
      this.sngListApi(params).then(() => {
        var data = self.sng.sngList;
        for (var i = 0; i < data.length; i++) {
          data[i].startTime =
            data[i].startTime == "0" || !data[i].startTime
              ? "-"
              : utils.getUTime(data[i].startTime);
          data[i].createTime =
            data[i].createTime == "0" || !data[i].createTime
              ? "-"
              : utils.getUTime(data[i].createTime);
        }
        this.loading = false;
      });
    },
    checkGame(id) {
      //   this.loading = true;
      // //   this.centerDialogVisible = true;
      //   let params = {
      //     matchId: id
      //   };
      //   this.sngDetailApi(params).then(() => {
      //     this.loading = false;
      //     this.$message.success('获取成功');
      //   });
      this.$router.push({ name: "awardDetail", query: { matchId: id } });
    },
    dismissGame(id) {
      this.loading = true;
      let params = {
        matchId: id,
        userId: localStorage.userId,
      };
      this.disSngApi(params).then(() => {
        this.loading = false;
        this.$message.success("删除成功");
        this.searchGame();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
:global(.el-icon-edit-outline) {
  color: $theme-color;
  cursor: pointer;
}
</style>
